/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthApis } from "../../apis/authApis";
import { useDispatch } from "react-redux";
import { login } from "../../reducer/loginSlice";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdDashboard } from "react-icons/md";
import { IoSchoolOutline } from "react-icons/io5";
import { RiSwapLine } from "react-icons/ri";
import { CiShare2, CiShop, CiWallet } from "react-icons/ci";
import { Cloud, Mail, Play } from 'lucide-react';
import { DashboardApi } from "../../apis/DashboardApi";
import SubscriptionStatus from "../../Components/Screens/User/SubscriptionStatus";
import SubscriptionStatusService from "../../services/SubscriptionStatusService";
import AccountSuspensionModal from "../../Components/Screens/User/AccountSuspensionModal";
import { AxiosInstance } from "axios";
import { shared } from "../../reducer/SharedSlice";

interface StorageBarProps {
  used: number;
  total: number;
}

const formatSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes.toFixed(1)}MB`; // If less than 1GB, show in MB
  else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)}GB`; // If less than 1TB, show in GB
  else return `${(bytes / (1024 * 1024)).toFixed(2)}TB`; // Otherwise, show in TB
};

const StorageBar: React.FC<StorageBarProps> = ({ used, total }) => {
  const percentage = (used / total) * 100;

  return (
    <div className="w-full">
      <div className="flex justify-between text-sm mb-1">
        <span>{formatSize(used)}</span>
        <span>{formatSize(total)}</span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full">
        <div
          className="h-full bg-blue-600 rounded-full"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default function Sidebar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const sharedData = useSelector((state: any) => state.data.shared.value);
  const [media, setMedia] = useState<any>(sharedData?.data);
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const [eduSilver, setEduSilver] = useState(false);
  const [eduGold, setEduGold] = useState(false);
  const [eduPremium, setEduPremium] = useState(false);
  const [showSuspensionModal, setShowSuspensionModal] = useState(false);

  useEffect(() => {
    if (sharedData?.data) {
      setMedia(sharedData.data);
    }
  }, [sharedData]);

  // console?.log(sharedData)

  // Initialize subscription status monitoring
  useEffect(() => {
    if (userLoginData?.token) {

      DashboardApi.getMediaUsage().then(
        (response2: any) => {
          if (response2?.data) {
            dispatch(shared({ data: response2?.data?.data }))
          }
        })

      // Set up subscription monitoring
      SubscriptionStatusService.getInstance()
        .onSuspension(() => setShowSuspensionModal(true))
        .startMonitoring();

      // Check if account is already flagged as suspended
      if (userLoginData.accountSuspended) {
        setShowSuspensionModal(true);
      }
    }

    return () => {
      // Clean up when component unmounts
      SubscriptionStatusService.getInstance().stopMonitoring();
    };
  }, [userLoginData?.token]);

  // Check for token and redirect if not present
  useEffect(() => {
    if (!userLoginData.token) {
      removeAuth();
    }
  }, []);

  const removeAuth = () => {
    dispatch(login([]))
    navigate("/sign-in");
  };

  const logOut = () => {
    AuthApis.logout('').then(
      (response: any) => {
        if (response?.data) {
          dispatch(login([]))
          navigate('/sign-in');
        }
      }
    ).catch(function (error) {
      // handle error
      dispatch(login({
        email: "",
        name: "",
        password: "",
        token: "",
        data: []
      }))
      navigate('/sign-in');
      console.log(error.response.data);
    }).finally(function () {
      dispatch(login({
        email: "",
        name: "",
        password: "",
        token: "",
        data: []
      }))
      navigate('/sign-in');
    });
  };

  // DrawerToggle
  const drawerToggle = (section: string) => {
    section === "silver" ? setEduSilver(true) : setEduSilver(false);
    section === "gold" ? setEduGold((prev: any) => !prev) : setEduGold(false);
    section === "premium" ? setEduPremium((prev: any) => !prev) : setEduPremium(false);
  };


  const [unreadMediaCount, setUnreadMediaCount] = useState(0);

  // Add this useEffect to fetch unread count
  // useEffect(() => {
  //   // Fetch unread media count
  //   const fetchUnreadCount = async () => {
  //     try {
  //       const response:any = await DashboardApi.getUnreadMediaCount();
  //       if (response.data?.status === 'success') {
  //         setUnreadMediaCount(response.data.unread_count);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching unread count:', error);
  //     }
  //   };

  //   // Initial fetch
  //   fetchUnreadCount();

  //   // Set up polling interval (every 5 minutes)
  //   const interval = setInterval(fetchUnreadCount, 5 * 60 * 1000);

  //   // Clean up
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      {/* Suspension Modal */}
      <AccountSuspensionModal
        isOpen={showSuspensionModal}
        onClose={() => setShowSuspensionModal(false)}
      />

      <nav className="bg-[white] md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 pl-6 pr-2">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex  justify-between w-full">
          {/* Toggler */}
          <div className="flex justify-between">
            <div className="mr-56">
              <button
                className="cursor-pointer text-black opacity-50 md:hidden  py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                type="button"
                onClick={() => setCollapseShow("bg-[#05401C] m-2 py-3 px-6")}
              >
                <b className="fas fa-bars"> ≡ </b>
              </button>
            </div>
            <div className=" flex justify-end">
              <Link
                className="md:hidden block "
                to="/dashboard"
              >
                <img src="/images/log.svg" alt="logo" className="w-[100px]" />
              </Link>
            </div>
          </div>

          {/* Collapse */}
          <div
            className={
              "bg-[white] md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className=" md:min-w-full md:hidden block  mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/dashboard"
                  >
                    <img src="/images/log.svg" alt="logo" className="w-[100px]" />
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <b className="fas fa-times"> X </b>
                  </button>
                </div>
              </div>
            </div>

            <div className="lg:flex md:flex hidden justify-center">
              <NavLink to="/dashboard" >
                <img src="/images/log.svg" alt="logo" className="max-w-[120px]" />
              </NavLink>
            </div>

            {/* Subscription Status Notification */}
            <SubscriptionStatus className="mt-4 mx-2" />

            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mt-8">
              <li className="items-center mb-2">
                <NavLink to="/dashboard" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <MdDashboard className="" size={24} />
                  <span className="mt-0.5"> Home</span>
                </NavLink>
              </li>

              <li className="items-center mb-2">
                <NavLink to="/my-media" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <IoSchoolOutline className="" size={24} />
                  <span className="mt-0.5"> My Media</span>
                </NavLink>
              </li>

              <li className="items-center mb-2">
                <NavLink to="/group-media" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <CiShare2 className="" size={24} />
                  <span className="mt-0.5"> Group Media</span>
                </NavLink>
              </li>

              {/* <ActionCard icon={Clock} title="Schedule Media" link='/scheduled-media'/> */}

              <li className="items-center mb-2">
                <NavLink to="/recipient" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <RiSwapLine className="" size={24} />
                  <span className="mt-0.5">Recipient</span>
                </NavLink>
              </li>


              <li className="items-center mb-2">
                <NavLink to="/scheduled-media" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <RiSwapLine className="" size={24} />
                  <span className="mt-0.5">Schedule Media</span>
                </NavLink>
              </li>

              <NavLink
                to="/received-media"
                className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
              >
                <Mail className="w-5 h-5" />
                <span>Received Media</span>
                {/* {unreadMediaCount > 0 && (
                  <span className="ml-auto bg-blue-500 text-white text-xs font-medium px-2 py-0.5 rounded-full">
                    {unreadMediaCount}
                  </span>
                )} */}
              </NavLink>

              <li className="items-center mb-2">
                <NavLink to="/legacy" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <CiWallet className="" size={24} />
                  <span className="mt-0.5">Legacy</span>
                </NavLink>
              </li>

              <li className="items-center mb-2 mt-2">
                <NavLink to="/user-settings" className="flex mx-2 py-[10px] pl-[15px] gap-2 rounded-[37px] text-[12px] text-[#6E7093] hover:bg-[#FFDCCC] hover:text-[#FF5200]"
                  style={({ isActive }) =>
                    isActive ? { color: '#FF5200', background: "#FFDCCC" } : { color: '' }
                  }
                >
                  <CiShop className="" size={24} />
                  <span className="mt-0.5"> Settings</span>
                </NavLink>
              </li>

              <li className="items-center">
                <button
                  onClick={logOut}
                  className="flex items-center gap-2 text-[#DB1E36] p-3 w-full hover:bg-gray-100 rounded-lg"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
                  </svg>
                  <span className="font-medium">Log out</span>
                </button>
              </li>

              <div className="mt-8 bg-[#FFF9F3] p-2 rounded-lg">
                <h3 className="text-sm font-medium mb-2 flex gap-2"><Cloud className="" size={24} /><span className="pt-1">Storage</span></h3>
                <StorageBar used={media?.total_used_mb ? (media?.total_used_mb) : 0.0} total={media?.max_limit_mb} />

                <NavLink to={'/upgrade'} className=' cursor-pointer'>
                  <button className="mt-4 w-full bg-[#00B07B] text-white py-2 px-4 rounded-lg hover:bg-[#009B6E]">
                    Get more Storage
                  </button>
                </NavLink>
              </div>

              <div className="mt-8 bg-black text-white p-6 rounded-lg">
                <h2 className="text-xl font-bold mb-4">Celebrating the richness of your past</h2>
                {/* <button className="bg-orange-500 p-2 rounded-full">
                  <Play className="w-4 h-4" />
                </button> */}
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}